teams-index
  forms-teams-search(tag-scope="forms_teams_search")
  teams-table(tag-scope="teams_table")
  script(type="typescript").
    this.mixin('base');
